import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, isRef as _isRef, vModelDynamic as _vModelDynamic, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["placeholder", "type", "name"]
const _hoisted_3 = { class: "v-input__error" }

import { useVModel } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'VInput',
  props: {
    modelValue: null,
    label: null,
    placeholder: null,
    type: null,
    error: null,
    name: null,
    disabled: { type: Boolean }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as { 
  modelValue?: string, 
  label?: string, 
  placeholder?: string, 
  type?: string, 
  error?: string,
  name?: string,
  disabled?: boolean
}




const model = useVModel(props, 'modelValue', emit)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["v-input", { errored: !!props.error, disabled: props.disabled }])
  }, [
    (props.label)
      ? (_openBlock(), _createElementBlock("label", _hoisted_1, _toDisplayString(props.label), 1))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(model) ? (model).value = $event : null)),
      placeholder: props.placeholder,
      type: props.type,
      name: __props.name
    }, null, 8, _hoisted_2), [
      [_vModelDynamic, _unref(model)]
    ]),
    _createElementVNode("div", _hoisted_3, _toDisplayString(props.error), 1),
    _renderSlot(_ctx.$slots, "append")
  ], 2))
}
}

})